import Vue from 'vue'
import Router from 'vue-router'

import menuModule from 'vuex-store/modules/menu'
import lazyLoading from 'vuex-store/modules/menu/lazyLoading'

Vue.use(Router)

const demoRoutes = []
if (process.env.NODE_ENV === 'development') {
  const VueComponentTree = require('vue-component-tree')

  demoRoutes.push(
    VueComponentTree.default(require.context('./..', true, /.demo.vue$/), '/demo')
  )
}

// Rutas fuera del menú lateral (no aparecen en sidebar)
const hiddenRoutes = [
  {
    name: 'padronPushHistory',
    path: '/push-history',
    component: lazyLoading('config/PushHistory'),
    meta: { title: 'Historial Push', requiresAuth: true }
  }
]

export default new Router({
  routes: [
    ...demoRoutes,
    ...generateRoutesFromMenu(menuModule.state.items),
    ...hiddenRoutes,
    {
      path: '*',
      redirect: { name: getDefaultRoute(menuModule.state.items).name }
    }
  ]
})

function generateRoutesFromMenu (menu = [], routes = []) {
  for (let i = 0, l = menu.length; i < l; i++) {
    let item = menu[i]
    if (item.path) {
      routes.push(item)
    }
    if (item.children) {
      generateRoutesFromMenu(item.children, routes)
    }
  }
  return routes
}

function getDefaultRoute (menu = []) {
  let defaultRoute

  menu.forEach((item) => {
    if (item.meta.default) {
      defaultRoute = item
    } else if (item.children) {
      let defaultChild = item.children.find((i) => i.meta.default)
      defaultRoute = defaultChild || defaultRoute
    }
  })

  return defaultRoute
}



// WEBPACK FOOTER //
// ./src/router/index.js